import { I18nLanguageCode, I18nLocale } from 'utils';
import { parse as qsParse } from 'qs';
import { useSettings } from '@/shared/context/settings-context';

function useCurrentFullUrl(): string {
  const { fullUrl } = useSettings();

  return fullUrl;
}

export function useCurrentUrl(): string {
  const { url } = useSettings();

  return url;
}

export function useCurrentHost(): string {
  const { host } = useSettings();

  return host;
}

export function useCurrentLocale(): I18nLocale {
  const { locale } = useSettings();

  return locale as I18nLocale;
}

export function useCurrentLanguageCode(): I18nLanguageCode {
  const { languageCode } = useSettings();

  return languageCode as I18nLanguageCode;
}

export function useCurrentQueryParams() {
  return qsParse(useCurrentFullUrl()?.split('?')?.[1] || '');
}
